/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as PostsSlugIdImport } from './routes/posts.$slug.$id'

// Create Virtual Routes

const IndexLazyImport = createFileRoute('/')()

// Create/Update Routes

const IndexLazyRoute = IndexLazyImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/index.lazy').then((d) => d.Route))

const PostsSlugIdRoute = PostsSlugIdImport.update({
  id: '/posts/$slug/$id',
  path: '/posts/$slug/$id',
  getParentRoute: () => rootRoute,
} as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexLazyImport
      parentRoute: typeof rootRoute
    }
    '/posts/$slug/$id': {
      id: '/posts/$slug/$id'
      path: '/posts/$slug/$id'
      fullPath: '/posts/$slug/$id'
      preLoaderRoute: typeof PostsSlugIdImport
      parentRoute: typeof rootRoute
    }
  }
}

// Create and export the route tree

export interface FileRoutesByFullPath {
  '/': typeof IndexLazyRoute
  '/posts/$slug/$id': typeof PostsSlugIdRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexLazyRoute
  '/posts/$slug/$id': typeof PostsSlugIdRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexLazyRoute
  '/posts/$slug/$id': typeof PostsSlugIdRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/posts/$slug/$id'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/posts/$slug/$id'
  id: '__root__' | '/' | '/posts/$slug/$id'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexLazyRoute: typeof IndexLazyRoute
  PostsSlugIdRoute: typeof PostsSlugIdRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexLazyRoute: IndexLazyRoute,
  PostsSlugIdRoute: PostsSlugIdRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/posts/$slug/$id"
      ]
    },
    "/": {
      "filePath": "index.lazy.tsx"
    },
    "/posts/$slug/$id": {
      "filePath": "posts.$slug.$id.tsx"
    }
  }
}
ROUTE_MANIFEST_END */
